import { useDispatch, useSelector } from 'react-redux';
import {
  updateHomeFormData,
  clearHomeFormData,
  selectHomeFormData,
  selectHomeFormDataByName,
} from '../redux/features/homeFormSlice';

const useHomeFormData = (formName) => {
  const dispatch = useDispatch();
  const allFormData = useSelector(selectHomeFormData);
  const formData = useSelector(selectHomeFormDataByName(formName));

  const saveHomeDataInRedux = (data) => {
    dispatch(updateHomeFormData({ formName, data }));
  };

  const getHomeFormData = () => {
    return formData;
  };

  const getAllHomeFormData = () => {
    return allFormData;
  };

  const clearHomeForm = (specificFormName = null) => {
    if (specificFormName) {
      dispatch(clearHomeFormData({ formName: specificFormName }));
    } else {
      dispatch(clearHomeFormData({ formName }));
    }
  };

  const clearAllHomeForms = () => {
    dispatch(clearHomeFormData({}));
  };

  return {
    formData,
    allFormData,
    saveHomeDataInRedux,
    getHomeFormData,
    getAllHomeFormData,
    clearHomeForm,
    clearAllHomeForms,
  };
};

export default useHomeFormData;